import { render, staticRenderFns } from "./KasdaPotonganTable.vue?vue&type=template&id=232c77f8&lang=pug"
import script from "./KasdaPotonganTable.vue?vue&type=script&lang=js"
export * from "./KasdaPotonganTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports